export default function cleanTanzaniaPhoneNumber(number) {
  // Remove any spaces or non-numeric characters
  number = number.replace(/\D/g, "");

  // Check if the number has more than 12 digits from the start
  if (number.length > 12) {
    return {
      error: "Invalid number length for Tanzania. Length must be 12 digits.",
    };
  }

  // Check if the number starts with '0' and add '255', removing the '0'
  if (number.startsWith("0")) {
    number = "255" + number.substring(1); // Remove '0' and prepend '255'
  }

  // If the number has 9 digits (e.g., 712345678), prepend '255'
  if (number.length === 9) {
    number = "255" + number;
  }

  // Validate the format after ensuring it starts with '255'
  if (!number.startsWith("255")) {
    return { error: "Invalid number format. Must start with 255 or 0." };
  }

  // Check if the number has too many digits after starting with '255'
  if (number.length > 12 && number.startsWith("255")) {
    return {
      error: "Invalid number length for Tanzania. Length must be 12 digits.",
    };
  }

  // Check final length to ensure it's exactly 12 digits
  if (number.length !== 12) {
    return {
      error: "Invalid number length for Tanzania. Length must be 12 digits.",
    };
  }

  return { cleanedNumber: number };
}
